import Datagent                              from 'datagent';
import {respondData, requestHandle} from '../utils';
import Fecha                                 from '../utils/type/Fecha';
import {defaults}                            from 'datagent/src/utils';

const {filter, format, getField, awaitTo} = Datagent.Hooks;

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const name = 'negativeSentiment/list';
const Model = Datagent.Model({
    name,
    fields : {
        'title'               : {type: String, default: ''}, // 标题
        'industryId'          : {type: String, default: ''}, // 行业id
        'stockCode'           : {type: String, default: ''}, // 股票代码
        'secondTargetNum'     : {type: String, default: ''}, // 二级指标编号
        'firstTargetNum'      : {type: String, default: ''}, // 一级指标编号
        'url'                 : {type: String, default: ''}, // 文章链接
        'year'                : {type: Fecha, default: ''},  // 项目年
        'sentimentList'       : { type: Array, default: [] },//负面行为列表
        'number'              : { type: Number, default: 0 },//数量
    },
    methods: {
        saveNegativeSentiment (params, opts) {
            const {origin} = defaults(opts);
            return this.remote(origin).put(`/negativeSentiment/`, params)
        },
        createNegativeSentiment (params, opts) {
            const {origin} = defaults(opts);
            return this.remote(origin).post(`/negativeSentiment/`, params)
        },
        deleteNegativeSentiment(params, opts) {
            const { origin } = defaults(opts);
            const { id, ...query } = params;
            if (typeof id == 'undefined') throw new Error('The id must be have of params!')
            return this.remote(origin).delete(`/negativeSentiment/${id}`, { id });
        },
        exportNegativeSentiment(params, opts) {
            const { origin } = defaults(opts);
            const { type, ...query } = params;
            return this.remote(origin).get(`/negativeSentiment/list/export`, query)
        },
        secondTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`/negativeSentiment/secondTarget`, params)
        },
        secondTargetExport(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`/negativeSentiment/secondTarget/export`, params)
        },
        sentimentNumber(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`/negativeSentiment/company/sentimentNumber`, params)
        },
        sentimentNumberExport(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`/negativeSentiment/company/sentimentNumber/export`, params)
        },
    },
    hooks  : {
        ...Datagent.mapSendHook([format()]),
        fetch              : {after: [respondData(), requestHandle(), getField('data', format())]},
        find               : {after: [respondData(), requestHandle(), format()]},
        exportNegativeSentiment : {after: [respondData(), requestHandle()]},
        secondTarget: { after: [respondData(), requestHandle(), getField('data', format())] },
        secondTargetExport: { after: [respondData(), requestHandle()] },
        sentimentNumber: { after: [respondData(), requestHandle()] },
        sentimentNumberExport: { after: [respondData(), requestHandle()] },
    }
});

Model.ModelName   = name;
export default Model;
